<nb-card class="placement-history-dialog" style="min-width: 560px; max-width: 760px; max-height: 80vh;">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <div>
      <h5 class="mb-0">Placement History</h5>
      <small *ngIf="productName" class="text-muted">for {{ productName }}</small>
    </div>
    <button class="btn btn-ghost-danger btn-sm" type="button" (click)="close()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body style="overflow-y: auto;">
    <div *ngIf="loading" class="text-center py-4">
      <nb-spinner size="medium"></nb-spinner>
      <p class="text-muted mt-2 mb-0">Loading placement history…</p>
    </div>

    <div *ngIf="!loading && placements.length === 0" class="text-center py-4 text-muted">
      <nb-icon icon="map-outline" style="font-size: 2rem;"></nb-icon>
      <p class="mt-2 mb-0">No placement history recorded yet.</p>
    </div>

    <div *ngIf="!loading && placements.length > 0" class="placement-history-list">
      <div class="placement-history-item" *ngFor="let placement of placements">
        <div class="d-flex justify-content-between align-items-start gap-3">
          <div>
            <div class="placement-summary">{{ formatPlacementSummary(placement) }}</div>
            <div class="placement-meta text-muted small mt-1">
              <span *ngIf="placement.shelfCapacityUnits != null">Capacity: {{ placement.shelfCapacityUnits }}</span>
              <span *ngIf="placement.shelfFacings != null" [class.ms-2]="placement.shelfCapacityUnits != null">
                Facings: {{ placement.shelfFacings }}
              </span>
            </div>
          </div>
          <div class="text-end">
            <span *ngIf="placement.isActive" class="badge bg-success">Current</span>
            <div class="text-muted small mt-1">{{ formatDate(placement.createdAt) }}</div>
          </div>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer class="d-flex justify-content-end">
    <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
  </nb-card-footer>
</nb-card>
